import { setDepositTrackingInfo } from '../state/actions/walletActions';

export const tryToSetIncomeAccessDepositTrackingInfo = (depositAmount: number, transactionId: number | undefined) => {
  if (transactionId !== undefined) {
    setDepositTrackingInfo({ transactionId, depositAmount });
  }
};
